import React, { useCallback } from "react";
import SidebarTop from "./SidebarTop";
import SidebarMain from "./SidebarMain";

const Sidebar2 = ({
  isOpen,
  onExpandSidebar,
  collapsedWidth = 80,
  expandedWidth = 320,
  minExpandedWidth = 288,
  maxExpandedWidth = 520,
  onExpandedWidthChange,
}) => {
  const handleResizeStart = useCallback(
    (event) => {
      if (!isOpen || typeof onExpandedWidthChange !== "function") return;

      event.preventDefault();

      const startX = event.clientX;
      const startWidth = expandedWidth;

      const handleMouseMove = (moveEvent) => {
        const deltaX = moveEvent.clientX - startX;
        const nextWidth = Math.min(
          maxExpandedWidth,
          Math.max(minExpandedWidth, startWidth + deltaX)
        );
        onExpandedWidthChange(nextWidth);
      };

      const handleMouseUp = () => {
        document.body.style.userSelect = "";
        document.body.style.cursor = "";
        window.removeEventListener("mousemove", handleMouseMove);
      };

      document.body.style.userSelect = "none";
      document.body.style.cursor = "col-resize";
      window.addEventListener("mousemove", handleMouseMove);
      window.addEventListener("mouseup", handleMouseUp, { once: true });
    },
    [
      expandedWidth,
      isOpen,
      maxExpandedWidth,
      minExpandedWidth,
      onExpandedWidthChange,
    ]
  );

  return (
    <div
      className={`
        relative
        bg-gradient-to-b from-white to-gray-50/80
        shadow-[2px_0_8px_-2px_rgba(0,0,0,0.06)]
        transition-all 
        duration-300 
        fixed 
        inset-y-0 
        left-0 
        z-40 
        overflow-y-auto
        overflow-x-hidden
        border-r border-gray-200/80
      `}
      style={{
        width: isOpen ? `${expandedWidth}px` : `${collapsedWidth}px`,
        scrollbarWidth: "thin",
        scrollbarColor: "#d1d5db transparent",
      }}
    >
      {/* Sidebar Top (Logo) */}
      <SidebarTop isOpen={isOpen} />

      {/* Sidebar Main (Navigation Links) */}
      <div className="flex-1 pb-4">
        <SidebarMain isOpen={isOpen} onExpandSidebar={onExpandSidebar} />
      </div>

      {isOpen && typeof onExpandedWidthChange === "function" && (
        <button
          type="button"
          onMouseDown={handleResizeStart}
          className="absolute top-0 right-0 h-full w-1.5 cursor-col-resize bg-transparent hover:bg-sky-100/80 active:bg-sky-200/80 transition-colors"
          aria-label="Resize sidebar width"
        />
      )}
    </div>
  );
};

export default Sidebar2;
